class ProductAccordionAnimations {
  constructor() {
    // Target accordions in product info section
    this.accordions = document.querySelectorAll('.product__accordion.accordion details');
    this.init();
  }

  init() {
    this.accordions.forEach(accordion => {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('.accordion__content');
      const icon = accordion.querySelector('.icon-caret');
      
      if (!summary || !content) return;

      // Set initial state
      if (!accordion.hasAttribute('open')) {
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.3s ease-in-out';
      }

      // Add click event listener
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(accordion, content, icon);
      });

      // Handle initial open state
      if (accordion.hasAttribute('open')) {
        this.setOpenState(content, icon);
      }
    });
  }

  toggleAccordion(accordion, content, icon) {
    const isOpen = accordion.hasAttribute('open');
    
    if (isOpen) {
      this.closeAccordion(accordion, content, icon);
    } else {
      this.openAccordion(accordion, content, icon);
    }
  }

  openAccordion(accordion, content, icon) {
    // Set open attribute
    accordion.setAttribute('open', '');
    
    // Animate icon rotation
    if (icon) {
      icon.style.transition = 'transform 0.3s ease-in-out';
      icon.style.transform = 'rotate(180deg)';
    }
    
    // Animate content height
    const contentHeight = content.scrollHeight;
    content.style.height = contentHeight + 'px';
    
    // After animation completes, remove height constraint
    setTimeout(() => {
      content.style.height = 'auto';
      content.style.overflow = 'visible';
    }, 300);
  }

  closeAccordion(accordion, content, icon) {
    // Animate icon rotation back
    if (icon) {
      icon.style.transition = 'transform 0.3s ease-in-out';
      icon.style.transform = 'rotate(0deg)';
    }
    
    // Set height to current scroll height before animating
    const contentHeight = content.scrollHeight;
    content.style.height = contentHeight + 'px';
    content.style.overflow = 'hidden';
    
    // Force reflow
    content.offsetHeight;
    
    // Animate to 0 height
    content.style.height = '0px';
    
    // Remove open attribute after animation
    setTimeout(() => {
      accordion.removeAttribute('open');
    }, 300);
  }

  setOpenState(content, icon) {
    // For initially open accordions, set proper state
    content.style.height = 'auto';
    content.style.overflow = 'visible';
    content.style.transition = 'height 0.3s ease-in-out';
    
    if (icon) {
      icon.style.transition = 'transform 0.3s ease-in-out';
      icon.style.transform = 'rotate(180deg)';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductAccordionAnimations();
  });
} else {
  new ProductAccordionAnimations();
}

// Reinitialize for theme editor updates
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.product__accordion')) {
    new ProductAccordionAnimations();
  }
});

// Also handle when product page is dynamically loaded
document.addEventListener('shopify:section:reorder', () => {
  new ProductAccordionAnimations();
});